/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlatformAnalyticsSummary } from './PlatformAnalyticsSummary';
import {
    PlatformAnalyticsSummaryFromJSON,
    PlatformAnalyticsSummaryFromJSONTyped,
    PlatformAnalyticsSummaryToJSON,
    PlatformAnalyticsSummaryToJSONTyped,
} from './PlatformAnalyticsSummary';
import type { PlatformAnalyticsTopEntity } from './PlatformAnalyticsTopEntity';
import {
    PlatformAnalyticsTopEntityFromJSON,
    PlatformAnalyticsTopEntityFromJSONTyped,
    PlatformAnalyticsTopEntityToJSON,
    PlatformAnalyticsTopEntityToJSONTyped,
} from './PlatformAnalyticsTopEntity';
import type { PlatformAnalyticsTrendPoint } from './PlatformAnalyticsTrendPoint';
import {
    PlatformAnalyticsTrendPointFromJSON,
    PlatformAnalyticsTrendPointFromJSONTyped,
    PlatformAnalyticsTrendPointToJSON,
    PlatformAnalyticsTrendPointToJSONTyped,
} from './PlatformAnalyticsTrendPoint';
import type { PlatformAnalyticsEntityBreakdown } from './PlatformAnalyticsEntityBreakdown';
import {
    PlatformAnalyticsEntityBreakdownFromJSON,
    PlatformAnalyticsEntityBreakdownFromJSONTyped,
    PlatformAnalyticsEntityBreakdownToJSON,
    PlatformAnalyticsEntityBreakdownToJSONTyped,
} from './PlatformAnalyticsEntityBreakdown';

/**
 * 
 * @export
 * @interface PlatformAnalyticsResponse
 */
export interface PlatformAnalyticsResponse {
    /**
     * 
     * @type {string}
     * @memberof PlatformAnalyticsResponse
     */
    timeFilter: string;
    /**
     * ISO date string (YYYY-MM-DD)
     * @type {string}
     * @memberof PlatformAnalyticsResponse
     */
    startDate: string;
    /**
     * ISO date string (YYYY-MM-DD)
     * @type {string}
     * @memberof PlatformAnalyticsResponse
     */
    endDate: string;
    /**
     * ISO date of the earliest tracked event. Null if no data yet.
     * @type {string}
     * @memberof PlatformAnalyticsResponse
     */
    metricsAvailableFrom: string | null;
    /**
     * 
     * @type {PlatformAnalyticsSummary}
     * @memberof PlatformAnalyticsResponse
     */
    summary: PlatformAnalyticsSummary;
    /**
     * 
     * @type {{ [key: string]: PlatformAnalyticsEntityBreakdown; }}
     * @memberof PlatformAnalyticsResponse
     */
    byEntityType: { [key: string]: PlatformAnalyticsEntityBreakdown; };
    /**
     * 
     * @type {Array<PlatformAnalyticsTrendPoint>}
     * @memberof PlatformAnalyticsResponse
     */
    trendByDay: Array<PlatformAnalyticsTrendPoint>;
    /**
     * 
     * @type {Array<PlatformAnalyticsTopEntity>}
     * @memberof PlatformAnalyticsResponse
     */
    topEntities: Array<PlatformAnalyticsTopEntity>;
}

/**
 * Check if a given object implements the PlatformAnalyticsResponse interface.
 */
export function instanceOfPlatformAnalyticsResponse(value: object): value is PlatformAnalyticsResponse {
    if (!('timeFilter' in value) || value['timeFilter'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('metricsAvailableFrom' in value) || value['metricsAvailableFrom'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('byEntityType' in value) || value['byEntityType'] === undefined) return false;
    if (!('trendByDay' in value) || value['trendByDay'] === undefined) return false;
    if (!('topEntities' in value) || value['topEntities'] === undefined) return false;
    return true;
}

export function PlatformAnalyticsResponseFromJSON(json: any): PlatformAnalyticsResponse {
    return PlatformAnalyticsResponseFromJSONTyped(json, false);
}

export function PlatformAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFilter': json['timeFilter'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'metricsAvailableFrom': json['metricsAvailableFrom'],
        'summary': PlatformAnalyticsSummaryFromJSON(json['summary']),
        'byEntityType': (mapValues(json['byEntityType'], PlatformAnalyticsEntityBreakdownFromJSON)),
        'trendByDay': ((json['trendByDay'] as Array<any>).map(PlatformAnalyticsTrendPointFromJSON)),
        'topEntities': ((json['topEntities'] as Array<any>).map(PlatformAnalyticsTopEntityFromJSON)),
    };
}

export function PlatformAnalyticsResponseToJSON(json: any): PlatformAnalyticsResponse {
    return PlatformAnalyticsResponseToJSONTyped(json, false);
}

export function PlatformAnalyticsResponseToJSONTyped(value?: PlatformAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'metricsAvailableFrom': value['metricsAvailableFrom'],
        'summary': PlatformAnalyticsSummaryToJSON(value['summary']),
        'byEntityType': (mapValues(value['byEntityType'], PlatformAnalyticsEntityBreakdownToJSON)),
        'trendByDay': ((value['trendByDay'] as Array<any>).map(PlatformAnalyticsTrendPointToJSON)),
        'topEntities': ((value['topEntities'] as Array<any>).map(PlatformAnalyticsTopEntityToJSON)),
    };
}

